<div class="report">
  <div class="spacer"></div>
  <div class="logo">
    <img src="/assets/swedishwelcome.png" />
  </div>

  <div class="center">
    <h1>Rådgivarrapport</h1>
  </div>

  <div class="spacer"></div>
  <div class="center">
    <h2>{{ reportSummary?.report?.name }}</h2>
  </div>
  <div class="spacer"></div>
  <div class="center">
    <h2>{{ reportSummary?.report?.businessCategoryName }}</h2>
  </div>
  <div class="spacer"></div>
  <div class="center">
    <img src="/assets/reportpicture.jpg" />
  </div>
  <div class="spacer"></div>
  <div class="pageBreak"></div>

  @if (barChartLabels.length > 0) {
    <div class="chart">
      <canvas baseChart width="625" height="400"
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
      [type]="barChartType"></canvas>
    </div>
  }

  <div class="center">
    <h2>Totalt i procent {{ reportSummary?.report?.scorePercentage }}%</h2>
  </div>
  <div class="spacer"></div>
  <div class="center">
    <table>
      <tr>
        <td class="titleCell"><strong>Besök datum:</strong></td>
        <td class="contentCell">{{ $safeNavigationMigration(reportSummary?.report?.visitDate) | dateFormatter:false }}</td>
      </tr>
      <tr>
        <td class="titleCell"><strong>Ansvarig rådgivare:</strong></td>
        <td class="contentCell">{{ reportSummary?.report?.ownerName }}</td>
      </tr>
      <tr>
        <td class="titleCell"><strong>Diskuterade med:</strong></td>
        <td class="contentCell">{{ reportSummary?.report?.contactPerson }}</td>
      </tr>
    </table>
  </div>
  <div class="spacer"></div>

  <div class="pageBreak"></div>

  <h3>Introduktion och sammanfattning</h3>
  <hr />
  <div [innerHtml]="getHtml($safeNavigationMigration(reportSummary?.report?.summary))"></div>
  <div class="spacer"></div>
  <h3>Rekommenderade minimikrav</h3>
  <hr />
  <div [innerHtml]="getHtml($safeNavigationMigration(reportSummary?.requirementDescription))"></div>
  <div class="spacer"></div>
  <table class="reportTable">
    @for (requirement of reportSummary?.unfulfilledRequirements; track requirement) {
      <tr class="reportRow">
        <td class="reportCell">{{ requirement.name }} {{ requirement.description }}</td>
      </tr>
    }
  </table>
  <div class="pageBreak"></div>
  <h3>Bedömningar</h3>
  <hr />
  <table class="reportTable">
    @for (score of reportSummary?.scoreLevelInfo; track score) {
      <tr class="reportRow">
        <td class="reportCell nowrap">@if (score.scoreLevel >=0) {
          <span>{{ score.scoreLevel }} - </span>
        }{{ score.name }}</td>
        <td class="reportCell">{{ score.description }}</td>
      </tr>
    }
  </table>

  <div class="spacer"></div>
  <h3>Gränsvärden för den övergripande bedömningen</h3>
  <hr />
  <table class="reportTable">
    @for (score of reportSummary?.scoreLevelInfo; track score; let idx = $index) {
      <tr class="reportRow">
        @if (score.scoreLevel >=0) {
          <td class="reportCell">{{ getThreashold($safeNavigationMigration(reportSummary?.scoreLevelInfo), idx) }}</td>
        }
      </tr>
    }
  </table>

  @for (aspectGroup of reportSummary?.aspectGroups; track aspectGroup) {
    <div>
      <div class="pageBreak"></div>
      <h3>{{ aspectGroup.name }}</h3>
      <hr />
      <table class="reportTable">
        <tr>
          <th class="reportHeaderCell">Aspekt</th>
          <th class="reportHeaderCell" colspan="2">Bedömning</th>
          <th class="reportHeaderCell" colspan="2">Tidigare bedömning</th>
        </tr>
        @for (aspect of aspectGroup?.aspects; track aspect) {
          <tr class="reportRow">
            @if (aspect.scoreLevel >= 0) {
              <td class="reportCell defaultFont">{{ aspect.name }}</td>
              <td class="reportCell defaultFont">@if (aspect.scoreLevel >= 0) {
                <span>{{ aspect.scoreLevel }}</span>
              }</td>
              <td class="reportCell defaultFont">{{ aspect.scoreLevelName }}</td>
              <td class="reportCell defaultFont">@if (aspect.previousScoreLevel >= 0) {
                <span>{{ aspect.previousScoreLevel }}</span>
              }</td>
              <td class="reportCell defaultFont">{{ aspect.previousScoreLevelName }}</td>
            }
          </tr>
        }
        <tr class="reportRow">
          <td class="reportCell" style="text-align:right">Aspektgrupp totalt:</td>
          <td class="reportCell"><strong>{{ aspectGroup.scorePercentage }}%</strong></td>
          <td class="reportCell"><strong>{{ aspectGroup.scoreLevelName }}</strong></td>
          <td class="reportCell" colspan="2"></td>
        </tr>
      </table>
      <div class="spacer"></div>
      <h4>Kommentarer</h4>
      <hr />
      <div [innerHtml]="getHtml(aspectGroup.comments)"></div>
      @if (aspectGroup.previousComments) {
        <div>
          <div class="spacer"></div>
          <h4>Tidigare kommentarer</h4>
          <hr />
          <div [innerHtml]="getHtml(aspectGroup.previousComments)"></div>
        </div>
      }
      <div class="spacer"></div>
      @if (aspectGroup.proposals && aspectGroup.proposals.length > 0) {
        <div>
          <h4>Nya förslag</h4>
          <hr />
          <table class="reportTable">
            @for (proposal of aspectGroup.proposals; track proposal) {
              <tr>
                <td class="reportCell">
                  <div [innerHtml]="getHtml(proposal.details)"></div>
                  @if (proposal.comment) {
                    <div><br /><span [innerHtml]="getHtml(proposal.comment)"></span></div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      }
      @if (aspectGroup.previousProposals && aspectGroup.previousProposals.length > 0) {
        <div>
          <h4>Kvarstående förslag från föregående år</h4>
          <hr />
          <table class="reportTable">
            @for (proposal of aspectGroup.previousProposals; track proposal) {
              <tr>
                <td class="reportCell">
                  <div>@if (proposal.originalDate) {
                    <span>{{ proposal.originalDate | dateFormatter:false }}:&nbsp;</span>
                    }<span [innerHtml]="getHtml(proposal.details)"></span></div>
                    @if (proposal.comment) {
                      <div><br /><span [innerHtml]="getHtml(proposal.comment)"></span></div>
                    }
                  </td>
                </tr>
              }
            </table>
          </div>
        }
      </div>
    }

  </div>
